module.exports = __webpack_public_path__ + "static/media/btn_refresh.05b2f69c.svg";